module.exports = __webpack_public_path__ + "static/media/tingyu.08befbc2.jpg";